import React from 'react';
import PropTypes from 'prop-types';
import MLTextField from '../MLTextField/MLTextField';

const OverLabledTextBox = (props) => {
  const id = Math.random().toString(36).substring(7);
  return (
    <div className={props.overLabelContainerClassName}>
      <span id={id} className={props.overLabelClassName}>
        {props.overLabelTxt}
      </span>
      <MLTextField
        containerClassName={props.textFieldContainerClassName}
        className={props.textFieldClassName}
        labelledBy={id}
        focus={props.focus}
        disabled={props.disabled}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value}
        errorMessages={props.errorMessages}
        hasError={props.invalidError}
        {...props}
      />
    </div>
  );
};

OverLabledTextBox.propTypes = {
  focus: PropTypes.bool,
  overLabelContainerClassName: PropTypes.string,
  onChange: PropTypes.func,
  labelledBy: PropTypes.string,
  overLabelTxt: PropTypes.string,
  overLabelClassName: PropTypes.string,
  textFieldContainerClassName: PropTypes.string,
  textFieldClassName: PropTypes.string,
  disabled: PropTypes.bool,
  invalidError: PropTypes.object,
  errorMessages: PropTypes.array,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OverLabledTextBox;
